import UTILITY_API from "../utility_api";

const getActivityCodesForFundingInstrument = (funding_instrument, query) => {
  const matchingObjects = funding_instrument.filter((element) =>
    query.includes(element.funding_instrument)
  );

  const activityCodes = matchingObjects.map((obj) => ({
    funding_instrument: obj.funding_instrument,
    activity_codes: obj.activity_codes,
  }));

  return activityCodes.length > 0 ? activityCodes : null;
};

const fetchFundingInstrument = async (instrument) => {
  try {
    const funding_instrument = await fetch(UTILITY_API + "/funding_instrument");
    if (!funding_instrument.ok) {
      throw new Error(
        `First API call failed: ${funding_instrument.statusText}`
      );
    }
    const funding_instrument_data = await funding_instrument.json();
    const activityCodes = getActivityCodesForFundingInstrument(
      funding_instrument_data,
      instrument
    );

    if (activityCodes) {
      const flattenedActivityCodes = activityCodes.flatMap(
        (obj) => obj.activity_codes
      );
      let updateDataQuery = {
        activitycodes: flattenedActivityCodes.join(","),
      };
      return updateDataQuery;
    }
  } catch (error) {
    console.error("Failed to fetch data:", error);
  }
};

export const handleInstrumentHelper = async (selectedOption) => {
  let instrument = [];
  selectedOption.map((item) => {
    instrument.push(item.value);
  });
  let updateDataQuery = await fetchFundingInstrument(instrument);
  return updateDataQuery;
};
